export default "__VITE_ASSET__DWU_XNuz__"